<div class="mat-comp-wrapper" [class.topPadding]="topPad">
  @if (label !== '') {
    <div id="label">
      {{label}}
      @if (hasValidtor('require')) {
        <span class="reqIcon" id="require" #require > * </span>
      }
      @if (hasValidtor('info')) {
        <span id="info" #info insTooltip [cfg]="{text: getValidtor('info').displayText, position: {H: 'hCenter', V:'vTop'}, type: 'info'}"> ? </span>
      }
    </div>
  }
  @if (!ignoreValueManipulations) {
    <mat-checkbox class="checkbox" [ngStyle]="cbCustomStyle" [class.checkboxOnPanel]="checkboxOnPanel" [(ngModel)]="value" [disabled]="!enabled" [disableRipple]="true">
      {{checkboxText}}
    </mat-checkbox>
  } @else {
    <mat-checkbox  class="checkbox" [ngStyle]="cbCustomStyle" [class.checkboxOnPanel]="checkboxOnPanel" [disabled]="!enabled" [disableRipple]="true" [checked]="checked" (change)="onChange($event)">
      {{checkboxText}}
    </mat-checkbox>
  }
</div>
